/**
 * PROVISIONAL M3 COLLISION VALUES — USER TUNING REQUIRED.
 *
 * These values establish conservative collision/query behavior only. They have
 * not received the user-led movement-feel pass required by the M3 gate.
 */
export const PROVISIONAL_PHYSICS_CONFIG = Object.freeze({
  characterRadiusM: 0.34,
  characterHalfHeightM: 0.58,
  characterContactOffsetM: 0.025,
  controllerNormalNudgeM: 0.001,
  autostepMinimumWidthM: 0.22,
  groundProbeDistanceM: 0.18,
  minimumSlopeSlideAngleRadians: Math.PI * 0.42,
  provisionalBuildingColliderHeightM: 12,
  terrainFriction: 0.9,
  buildingFriction: 0.82,
  cameraCollisionRadiusM: 0.16,
  cameraCollisionSkinM: 0.06,
  mantleForwardDistanceM: 0.7,
  mantleClearanceM: 0.06,
});

export type PhysicsConfig = typeof PROVISIONAL_PHYSICS_CONFIG;
